module.exports = __webpack_public_path__ + "img/ReifenReiboldLogo.b3f5cb2c.png";